export default "/images/vendor/flag-icon-css/flags/1x1/nc.svg?8a6f511c5d92ba7a258cd85240d33623";